import * as React from 'react';

export interface SidebarBackButtonProps {
  /** Applied as data-hook HTML attribute that can be used to create driver in testing */
  dataHook?: string;
  /** Specifies a CSS class name to be appended to the component’s root element.
   * @internal
   */
  className?: string;
  /** click event handler  */
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  /** Text for the button */
  children?: string;
  /** Whether or not to constantly animate the arrow */
  animateArrow?: boolean;
}

export default class SidebarBackButton extends React.PureComponent<SidebarBackButtonProps> {}
